export default "__VITE_ASSET__SSHFHP4R__"